import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { LogOut, SetValidationError } from 'src/app/features/admin/stores/admin.action';
import { IAppState } from 'src/app/shared/shared.interface';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false,
})
export class HeaderComponent {
  constructor(private router: Router, private store: Store<IAppState>) {}

  logout() {
    this.store.dispatch(new SetValidationError(''));
    this.store.dispatch(new LogOut());

    // Clear all tokens and storage to ensure complete logout
    localStorage.clear();
    sessionStorage.clear();

    // Add cache control headers to prevent browser back button issues
    if (window.caches) {
      // Attempt to clear the Cache API if available
      caches.keys().then((keyList) => {
        return Promise.all(
          keyList.map((key) => {
            return caches.delete(key);
          })
        );
      });
    }

    // Force reload to clear any in-memory state
    this.router.navigateByUrl('/login', { replaceUrl: true });
  }

  // Method specifically mentioned in issue description
  checkLogout() {
    this.logout();
  }
}
